export const rowTypes = {
  HEADER: 'header',
  EMPTY: 'empty',
  SUMMARY: 'summary',
};
